import {fetch} from '../../helper/http';

const _tpl = require('lodash/template');

export default {
  template: '<span class="price-info" v-html="tpl"></span>',
  props:['scope','url','method','data','state','template','params','watch'],
  beforeMount:function(){
    if(this.data) vm.$watch(this.data,{
      deep: true,
      immediate: true,
      handler:this.fetchData
    });
    if(this.watch) this.watch.split(',').forEach(key=>{
      vm.$watch(key,{
        deep: true,
        handler:this.fetchData
      });
    });
  },
  mounted:function(){
    if(this.data) return;   
    this.fetchData();  //立即执行一次
  },
  methods:{
    fetchData:function(){
      if(!this.url) return;
      const url = this.url; 
      let data = this.params||vm[this.data];
      this.tpl = '...';
      fetch('GET',`${url}`,data)
      .then((result)=>{
        let {code,data} = result||{};
        if(code !=200) return;
        data = Array.isArray(data)?data[0]:data;
        //挂载到全局，直接覆盖
        if(this.state) (this.scope?window[this.scope]:vm)[this.state] = data; 
        //解析template 
        if(this.template) this.tpl = _tpl(this.template)(data);
      });
    }
  },
  data:function(){
    return {
      tpl:''
    };
  }
};


// WEBPACK FOOTER //
// ./src/components/price/index.js